<div class="seed-return-add-prod">
  <div class="prod-top-sec">
    <div class="row">
      <div class="col-12">
        <h2>Early Advantage Swap Product</h2>
        <div class="row">
          <div class="col-12">
            <!--<p class="bold">-->
            <p>
              Current Product: <span> {{counter}} of {{totalItems}} </span>
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col-12 margin-t5">
            <p>
              When swapping multiple products you'll be able to go through this interface for each product and make your modifications. Once you're done you'll be able to commit your order change.
            </p>
          </div>
          <div class="col-12 text-right">

            <div class="d-inline-block margin-r15">Display Early Advantage Eligible Units on Dealer Order</div>
            <mat-checkbox class="custom-checkbox align-top" [checked]="isDisplayEAEligibleUnitsChecked" (change)="loadDealerToItems($event)"></mat-checkbox>
          </div>
        </div>
      </div>
      <!--<div class="col-md-12 padding-l0 padding-r0 " *ngIf="showCutOverWarning">
        <div class="warningMsg">
          {{cutOverPackageSizeMessage}}
        </div>
      </div>-->
    </div>
  </div>
  <div class="row margin-l0 margin-r0">
    <div class="col-12 tabBgColor padding-t5 padding-l20">
      <div class="row">
        <div class="col-2"><h6>From:</h6></div>
        <div class="col-10"></div>
      </div>
      <div class="row">
        <div class="col-3">
          <h6>Product Name: </h6>
          <div class="thinFontProduct">{{fromProduct.brand}} - {{fromProduct.marketingBrand}}</div>
          <div class="margin-b10">{{fromProduct.itemDescription}}</div>
        </div>
        <div class="col-1">
          <h6 class="text-center">Seed Size</h6>
          <div class="text-center margin-b20">{{fromProduct.seedSize}}</div>
        </div>
        <div class="col-2">
          <h6 class="text-center">Package Size</h6>
          <div class="text-center margin-b20">{{fromProduct.packageSize}}</div>
        </div>
        <div class="col-2">
          <h6 class="text-center">Treatment</h6>
          <div class="text-center margin-b20">{{fromProduct.treatment}}</div>
        </div>
        <div class="col-2">
          <h6 class="text-center">Dealer Units</h6>
          <div class="text-center margin-b20">{{fromProduct.dealerUnits}}</div>
        </div>
        <div class="col-2">
          <h6 class="text-center">EA Modifiable Units</h6>
          <div class="text-center margin-b20">{{commonService.getFormatedNumber(fromProduct.eaModifiableUnits) | number}}</div>
        </div>
      </div>
    </div>
  </div>
  <div class="row margin-l0 margin-r0">
    <div class="col-12 margin-t10">
      <div class="row">
        <div class="col-12 padding-l0 padding-r0">
          <app-filter #eaSwapFilter [(optionsData)]="filterOptionsData" [isSearchButtonOutside]="true" (searchClick)="filterSearchClick($event)" (clearAllClick)="filterClearAllClick($event)"></app-filter>
        </div>
      </div>
    </div>

    <div class="col-12 tableHead whiteBg">
      To:
    </div>

    <div class="tableContainerSwap dealertableContainer table-mobile">
      <table mat-table [dataSource]="eaSwapProductDS" multiTemplateDataRows class="matTables">
        <ng-container matColumnDef="{{column}}" *ngFor="let column of displayColumns">
          <div *ngIf="column=='productName'"><th mat-header-cell *matHeaderCellDef class="shipToLocation">Product Name</th>
    </div>
    <div *ngIf="column=='seedSize'"><th mat-header-cell *matHeaderCellDef class="webOrderNumber text-center">Seed Size</th></div>
    <div *ngIf="column=='packageSize'"><th mat-header-cell *matHeaderCellDef class="orderCreateDate text-center">Package Size</th></div>
    <div *ngIf="column=='treatment'"><th mat-header-cell *matHeaderCellDef class="accountNumber text-center">Treatment</th></div>
    <div *ngIf="column=='dealerUnits'"><th mat-header-cell *matHeaderCellDef class="locationDetails text-center">Dealer Units</th></div>
    <div *ngIf="column=='eaUnits'"><th mat-header-cell *matHeaderCellDef class="locationDetails text-center">EA Units</th></div>
    <div *ngIf="column=='swapEaUnits'"><th mat-header-cell *matHeaderCellDef class="total-units text-center">Swap EA Units</th></div>
    <td mat-cell *matCellDef="let element">
      <div *ngIf="column=='productName'" class="shipToLocation" [attr.data-testid]="'ea-' + element.itemNumber">
        <div class="margin-t-15" matTooltip="{{ element.brand }} - {{
                    element.marketingBrand
                  }} #{{ element.itemNumber }}"
             [matTooltipPosition]="'above'"
             matTooltipClass="whiteFontCpp">
          <div class="thinFont">
            {{element.brand}} - {{element.marketingBrand}}
          </div>
          <div>
            {{element.itemDescription}}
          </div>
        </div>
      </div>
      <div *ngIf="column=='seedSize'" class="webOrderNumber text-center">
        <div class="margin-t-15">
          {{element.seedSize}}
        </div>
      </div>

      <div *ngIf="column=='packageSize'" class="orderCreateDate text-center">
        <div class="margin-t-15">
          {{element.packageSize}}
        </div>
      </div>

      <div *ngIf="column=='treatment'" class="accountNumber text-center">
        <div class="margin-t-15">
          {{element.treatment}}
        </div>
      </div>

      <div *ngIf="column=='dealerUnits'" class="locationDetails text-center">
        <div class="margin-t-15">
          {{element.dealerUnits}}
        </div>
      </div>

      <div *ngIf="column=='eaUnits'" class="locationDetails text-center">
        <div class="margin-t-15">
          {{element.eaUnits}}
        </div>
      </div>
      <div *ngIf="column=='swapEaUnits'" class="total-units text-center">
        <div class="order-info defaultCursor padding-l15 margin-t-15">
          <div>
            <button class="plus-minus-btn minusBtn" (click)="dealerUnitChange('decrease',element);" [attr.data-testid]="'decrease-ea-' + element.itemNumber"> - </button>
            <input type="text" class="geu-txt unitsText" [(ngModel)]="element.swapEAUnits" maxlength="5" NumbersOnly (focusout)="validateLineItem(element)" [attr.data-testid]="'qty-ea-' + element.itemNumber"/>
            <button class="plus-minus-btn plusBtn" (click)="dealerUnitChange('increase',element);" [attr.data-testid]="'increase-ea-' + element.itemNumber"> + </button>
          </div>
        </div>
      </div>
    </td>
    </ng-container>
    <ng-container matColumnDef="expandedDetail">
      <td mat-cell class="product-details" *matCellDef="let element" [attr.colspan]="displayColumns.length">
        <div class="inline-error" *ngIf="element.lineErrors && element.lineErrors.errors.length > 0" id="error_{{element.lineErrors.itemId}}">
          <div class="row">
            <div class="col-md-9">
              <ol class="error-list">
                <li *ngFor="let err of element.lineErrors.errors">
                  {{err.error}}
              </ol>
            </div>
          </div>
        </div>
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayColumns;sticky:true;"></tr>
    <tr mat-row *matRowDef="let element; columns: displayColumns;"
        [ngClass]="{'example-element-row':(1==1),'active':(element.lineErrors && element.lineErrors.errors.length > 0)}"></tr>
    <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row" [hidden]="this.showErrorBlock != true"></tr>
    </table>

    <div *ngIf="!eaSwapProductDS || eaSwapProductDS.length == 0" class="row noDataMsg">
      <p class="padding-b47">No Record Found.</p>
    </div>
  </div>
</div>

<div class="tableTotalsSec">
  <div class="row">
    <div class="col-md-9">
      <button mat-raised-button *ngIf="isShowPreviousBtn" class="btns" color="primary" (click)="MoveToPreviousItem()">Previous Line Item</button>
      <button mat-raised-button *ngIf="isShowNextBtn" class="btns" color="primary" (click)="MoveToNextItem('click')">Next Line Item</button>
      <button mat-raised-button *ngIf="isShowUpdateBtn" class="btns" color="primary" (click)="updateOrder()" [disabled]="errorMsgs && errorMsgs.length > 0">Update Order</button>
      <a class="pe-auto text-decoration-underline" style="cursor:pointer" (click)="cancelEaSwap()">Cancel </a>
    </div>
    <div class="col-md-3 text-right count">
      SWAP EA UNITS: <span>{{commonService.getFormatedNumber(totalSum) | number}}/{{commonService.getFormatedNumber(fromProduct.eaModifiableUnits) | number}}</span>
    </div>
  </div>
</div>
